import { FC, HTMLAttributes } from "react";

import clsx from "clsx";

import styles from "./index.module.css";

type HeaderTags = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
type HeaderWeight = "regular" | "bold";
export interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  className?: string;
  tag?: HeaderTags;
  size?: HeaderTags;
  fontWeight?: HeaderWeight;
}

const Heading: FC<HeadingProps> = props => {
  const { tag: Tag = "h6", size = Tag, fontWeight = "bold", className, ...rest } = props;

  return (
    <Tag className={clsx(styles[fontWeight], styles[size], className)} {...rest}>
      {props.children}
    </Tag>
  );
};

export default Heading;
